import { SvgIcon, SvgIconProps } from '@material-ui/core';

export const UpdloadAttachmentIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 17 16" fill="none" {...props}>
    <path
      d="M9.02947 1.72054C8.89013 1.57835 8.6993 1.5 8.49938 1.5C8.29947 1.5 8.10863 1.57835 7.9693 1.72054L4.09211 5.66696C3.81646 5.94844 3.83161 6.38661 4.1224 6.65067C4.41319 6.91473 4.8736 6.90022 5.14925 6.62165L7.77241 3.95201V6.375V10.0893C7.77241 10.4752 8.09652 10.7857 8.49938 10.7857C8.90225 10.7857 9.22636 10.4752 9.22636 10.0893V6.375V3.95201L11.8465 6.61875C12.1221 6.90022 12.5826 6.91183 12.8733 6.64777C13.1641 6.38371 13.1793 5.94263 12.9036 5.66406L9.02644 1.71763L9.02947 1.72054ZM3.41057 13.1071C3.0077 13.1071 2.68359 13.4176 2.68359 13.8036C2.68359 14.1895 3.0077 14.5 3.41057 14.5H13.5882C13.9911 14.5 14.3152 14.1895 14.3152 13.8036C14.3152 13.4176 13.9911 13.1071 13.5882 13.1071H3.41057Z"
      fill="currentColor"
    />
  </SvgIcon>
);
